module.exports = __webpack_public_path__ + "media/images/icons/filled/pushpin-5a22a1ac686025c05ba311a71c3efc1b.svg";